export const headerFix = (scope) => {
	let header = document.getElementsByClassName('js-page-header-wrap');
	let lastScrollY = window.scrollY;
	let scrolled = false;
	let fixed = false;
	let stop = true;
	let recalcTimeout = null;

	let passiveEventsSupported = (() => {
		// passive event listeners support test from MDN
		let result = false;
		try {
			window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
				get: () => result = true
			}));
		} catch (err) {}
		return result;
	})();

	if (!header.length) {
		return;
	}
	header = header[0];

	window.addEventListener('resize', handleResize, passiveEventsSupported ? {passive: true} : undefined);
	handleResize();

	function handleResize() {
		if (window.innerWidth >= 1000) {
			window.addEventListener('scroll', handleScroll, passiveEventsSupported ? {passive: true} : undefined);
			handleScroll();
		} else if (window.innerWidth <= 999) {
			window.removeEventListener('scroll', handleScroll);
			scope.classList.remove('state--header-fixed');
			scope.classList.remove('state--header-fixed-hidden');
			scope.classList.remove('state--header-scrolled');
		}
	}

	function handleScroll() {
		if (!recalcTimeout) {
			recalcTimeout = setTimeout(recalc, 50);
		}
	}

	function recalc() {
		// если скроллим вверх и достигли верхнего края экрана, или скроллим вниз и не проскроллили до конца хедер
		if (window.scrollY === 0) {
			if (!stop) {
				scope.classList.remove('state--header-fixed');
				scope.classList.remove('state--header-fixed-hidden');
				stop = true;
				fixed = false;
			}
		} else {
			// если скроллим где-то среди страницы
			// скролл вверх - фиксируем
			if (!fixed && lastScrollY > window.scrollY) {
				//scope.classList.remove('state--header-static');
				scope.classList.add('state--header-fixed');
				scope.classList.remove('state--header-fixed-hidden');
				stop = false;
				fixed = true;
			} else if (fixed && lastScrollY < window.scrollY && window.scrollY > (header.offsetHeight + 100)) {
				// скролл вниз - прячем (и если хедер проскроллили)
				scope.classList.remove('state--header-fixed');
				scope.classList.add('state--header-fixed-hidden');
				stop = false;
				fixed = false;
			}
		}

		if (!scrolled && window.scrollY > (header.offsetHeight + 100)) {
			scope.classList.add('state--header-scrolled');
			scrolled = true;
		} else if (!fixed && scrolled && window.scrollY <= (header.offsetHeight + 100)) {
			scope.classList.remove('state--header-scrolled');
			scrolled = false;
		}

		lastScrollY = window.scrollY;
		recalcTimeout = null;
	}
};

export default headerFix;